<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="MB2236-MFP">
     MB2236-MFP
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_fi" title="Turvallisuusohjeet">
     Turvallisuusohjeet
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Merkint&auml;tavat">
      Merkint&auml;tavat
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-cable-topic.html#d0e42" title="Tuotelausunnot">
      Tuotelausunnot
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_fi" title="Tietoja tulostimesta">
     Tietoja tulostimesta
    </a>
   </p>
   <div id="divd0e172">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_fi" title="Tulostintietojen etsiminen">
      Tulostintietojen etsiminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number_fi" title="Tulostimien sarjanumeron etsiminen">
      Tulostimien sarjanumeron etsiminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configured-model-topic.html#configured-model_fi" title="Tulostimen kokoonpano">
      Tulostimen kokoonpano
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-group.html#d0e379" title="Ohjauspaneelin k&auml;ytt&auml;minen">
      Ohjauspaneelin k&auml;ytt&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="customizing-home-screen-topic.html#customizing-home-screen_fi" title="Aloitusn&auml;yt&ouml;n mukauttaminen">
      Aloitusn&auml;yt&ouml;n mukauttaminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-language-of-onscreen-keyboard-topic.html#changing-language-of-onscreen-keyboard_fi" title="N&auml;ytt&ouml;n&auml;pp&auml;imist&ouml;n kielen vaihtaminen">
      N&auml;ytt&ouml;n&auml;pp&auml;imist&ouml;n kielen vaihtaminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_fi" title="Virtapainikkeen valon ja merkkivalon tilan merkitys">
      Virtapainikkeen valon ja merkkivalon tilan merkitys
     </a>
    </p>
    <p class="toc-2-style">
     <a href="selecting-paper-group.html#d0e759" title="Paperin valinta">
      Paperin valinta
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_fi" title="K&auml;ytt&ouml;&ouml;notto, asennus ja kokoonpano">
     K&auml;ytt&ouml;&ouml;notto, asennus ja kokoonpano
    </a>
   </p>
   <div id="divd0e1623">
    <p class="toc-2-style">
     <a href="selecting-location-printer-m-topic.html#selecting-location-printer-m_fi" title="Tulostimen paikan valitseminen">
      Tulostimen paikan valitseminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_fi" title="Kaapelien liitt&auml;minen">
      Kaapelien liitt&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-printer-to-fax-group.html#d0e1818" title="Tulostimen asentaminen faksaamista varten">
      Tulostimen asentaminen faksaamista varten
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-smtp-server-for-e-mail-topic.html#configuring-smtp-server-for-e-mail_fi" title="S&auml;hk&ouml;postin SMTP-asetusten m&auml;&auml;ritt&auml;minen">
      S&auml;hk&ouml;postin SMTP-asetusten m&auml;&auml;ritt&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-paper-and-specialty-media-group.html#d0e3751" title="Paperin ja erikoismateriaalin asettaminen">
      Paperin ja erikoismateriaalin asettaminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e3884" title="Ohjelmiston, ohjaimien ja laiteohjelmiston asentaminen ja p&auml;ivitt&auml;minen">
      Ohjelmiston, ohjaimien ja laiteohjelmiston asentaminen ja p&auml;ivitt&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e4116" title="Verkkoyhteydet">
      Verkkoyhteydet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-cloud-connector-profile-topic.html#creating-cloud-connector-profile_fi" title="Cloud Connector -profiilin luominen">
      Cloud Connector -profiilin luominen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-h1-topic.html#printing-menu-settings-page-h1_fi" title="Valikkoasetussivun tulostus">
      Valikkoasetussivun tulostus
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_fi" title="Tulostimen suojaaminen">
     Tulostimen suojaaminen
    </a>
   </p>
   <div id="divd0e4634">
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_fi" title="Tulostinmuistin tyhjent&auml;minen">
      Tulostinmuistin tyhjent&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_fi" title="Oletusasetusten palautus">
      Oletusasetusten palautus
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility_fi" title="Haihtuvuusjulistus">
      Haihtuvuusjulistus
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_fi" title="Tulosta">
     Tulosta
    </a>
   </p>
   <div id="divd0e4756">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_fi" title="Tulostaminen tietokoneella">
      Tulostaminen tietokoneella
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e4782" title="Tulostaminen mobiililaitteesta">
      Tulostaminen mobiililaitteesta
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_fi" title="Tulostaminen Flash-asemasta">
      Tulostaminen Flash-asemasta
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_fi" title="Tuetut flash-asemat ja tiedostotyypit">
      Tuetut flash-asemat ja tiedostotyypit
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_fi" title="Luottamuksellisten t&ouml;iden m&auml;&auml;ritt&auml;minen">
      Luottamuksellisten t&ouml;iden m&auml;&auml;ritt&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_fi" title="Luottamuksellisten ja muiden pidossa olevien t&ouml;iden tulostaminen">
      Luottamuksellisten ja muiden pidossa olevien t&ouml;iden tulostaminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-cloud-connector-profile-topic.html#printing-from-cloud-connector-profile_fi" title="Tulostaminen Cloud Connector -profiilista">
      Tulostaminen Cloud Connector -profiilista
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-topic.html#printing-font-sample-lis_fi" title="Fonttimalliluettelon tulostaminen">
      Fonttimalliluettelon tulostaminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-topic.html#placing-separator-sheets_fi" title="Erotinsivujen lis&auml;&auml;minen kopioiden v&auml;liin">
      Erotinsivujen lis&auml;&auml;minen kopioiden v&auml;liin
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_fi" title="Tulostusty&ouml;n peruuttaminen">
      Tulostusty&ouml;n peruuttaminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#adjusting-toner-darkness_fi" title="V&auml;riaineen tummuuden s&auml;&auml;t&auml;minen">
      V&auml;riaineen tummuuden s&auml;&auml;t&auml;minen
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="copying.html#copying_fi" title="Kopio">
     Kopio
    </a>
   </p>
   <div id="divd0e5378">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_fi" title="Automaattisen asiakirjansy&ouml;tt&ouml;laitteen ja skannaustason k&auml;ytt&auml;minen">
      Automaattisen asiakirjansy&ouml;tt&ouml;laitteen ja skannaustason k&auml;ytt&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="making-copies-topic.html#making-copies_fi" title="Kopioiminen">
      Kopioiminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-photos-topic.html#copying-photos_fi" title="Valokuvien kopioiminen">
      Valokuvien kopioiminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-letterhead-topic.html#copying-letterhead_fi" title="Kopioiminen kirjelomakkeelle">
      Kopioiminen kirjelomakkeelle
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_fi" title="Paperin molemmille puolille kopioiminen">
      Paperin molemmille puolille kopioiminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="reducing-enlarging-copies-topic.html#reducing-enlarging-copies_fi" title="Kopioiden pienent&auml;minen tai suurentaminen">
      Kopioiden pienent&auml;minen tai suurentaminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="saving-paper-topic.html#saving-paper_fi" title="Useiden sivujen kopioiminen yhdelle arkille">
      Useiden sivujen kopioiminen yhdelle arkille
     </a>
    </p>
    <p class="toc-2-style">
     <a href="collating-copies-topic.html#collating-copies_fi" title="Kopioiden lajittelu">
      Kopioiden lajittelu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-cards-topic.html#copying-cards_fi" title="Korttien kopioiminen">
      Korttien kopioiminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-copy-shortcut-topic.html#creating-copy-shortcut_fi" title="Kopioinnin pikavalinnan luominen">
      Kopioinnin pikavalinnan luominen
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="e-mailing-chapter.html#e-mailing-chapter_fi" title="S&auml;hk&ouml;posti">
     S&auml;hk&ouml;posti
    </a>
   </p>
   <div id="divd0e5708">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-email-topic.html#using-ADF-and-scanner-glass-email_fi" title="Automaattisen asiakirjansy&ouml;tt&ouml;laitteen ja skannaustason k&auml;ytt&auml;minen">
      Automaattisen asiakirjansy&ouml;tt&ouml;laitteen ja skannaustason k&auml;ytt&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-email-topic.html#sending-email_fi" title="S&auml;hk&ouml;postin l&auml;hett&auml;minen">
      S&auml;hk&ouml;postin l&auml;hett&auml;minen
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="Faxing.html#Faxing_fi" title="Faksaa">
     Faksaa
    </a>
   </p>
   <div id="divd0e5823">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-fax-topic.html#using-ADF-and-scanner-glass-fax_fi" title="Automaattisen asiakirjansy&ouml;tt&ouml;laitteen ja skannaustason k&auml;ytt&auml;minen">
      Automaattisen asiakirjansy&ouml;tt&ouml;laitteen ja skannaustason k&auml;ytt&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-fax-topic.html#sending-fax_fi" title="Faksin l&auml;hett&auml;minen">
      Faksin l&auml;hett&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scheduling-fax-topic.html#sending-fax-scheduled-time_fi" title="Faksin ajastaminen">
      Faksin ajastaminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_fi" title="Faksin kohdepikavalinnan luominen">
      Faksin kohdepikavalinnan luominen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-fax-resolution-topic.html#changing-fax-resolution_fi" title="Faksin tarkkuuden muuttaminen">
      Faksin tarkkuuden muuttaminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-fax-darkness-topic.html#adjusting-fax-darkness_fi" title="Faksin tummuuden s&auml;&auml;t&auml;minen">
      Faksin tummuuden s&auml;&auml;t&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-fax-log-topic.html#printing-fax-log_fi" title="Faksilokin tulostaminen">
      Faksilokin tulostaminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="blocking-junk-faxes-topic.html#blocking-junk-faxes_fi" title="Roskafaksien est&auml;minen">
      Roskafaksien est&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="holding-faxes-topic.html#holding-faxes_fi" title="Faksien pys&auml;ytt&auml;minen">
      Faksien pys&auml;ytt&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forwarding-fax-topic.html#forwarding-fax_fi" title="Faksin v&auml;litt&auml;minen">
      Faksin v&auml;litt&auml;minen
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="FTP.html#FTP_fi" title="Skannaaminen">
     Skannaaminen
    </a>
   </p>
   <div id="divd0e6217">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-scan-topic.html#using-ADF-and-scanner-glass-scan_fi" title="Automaattisen asiakirjansy&ouml;tt&ouml;laitteen ja skannaustason k&auml;ytt&auml;minen">
      Automaattisen asiakirjansy&ouml;tt&ouml;laitteen ja skannaustason k&auml;ytt&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-computer-topic.html#scanning-to-computer_fi" title="Skannaaminen tietokoneeseen">
      Skannaaminen tietokoneeseen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-flash-drive-topic.html#scanning-to-flash-drive_fi" title="Skannaaminen flash-asemaan">
      Skannaaminen flash-asemaan
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-ftp-server-using-shortcut-topic.html#scanning-to-ftp-server-using-shortcut_fi" title="Skannaaminen FTP-palvelimeen">
      Skannaaminen FTP-palvelimeen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-network-folder-using-shortcut-topic.html#scanning-network-folder-using-shortcut_fi" title="Skannaaminen verkkokansioon">
      Skannaaminen verkkokansioon
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-cloud-connector-profile-topic.html#scanning-to-cloud-connector-profile_fi" title="Skannaaminen Cloud Connector -profiiliin">
      Skannaaminen Cloud Connector -profiiliin
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_fi" title="Tulostinvalikkojen k&auml;ytt&ouml;">
     Tulostinvalikkojen k&auml;ytt&ouml;
    </a>
   </p>
   <div id="divd0e6564">
    <p class="toc-2-style">
     <a href="menu-map-mfp-topic.html#menus-map-mfp_fi" title="Valikkokartta">
      Valikkokartta
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e6912" title="Laite">
      Laite
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e8548" title="Tulosta">
      Tulosta
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e9341" title="Paperi">
      Paperi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copy-defaults-topic.html#d0e9642" title="Kopio">
      Kopio
     </a>
    </p>
    <p class="toc-2-style">
     <a href="fax-defaults-subgroup.html#d0e9864" title="Faksaa">
      Faksaa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="email-setup-topic.html#d0e11486" title="S&auml;hk&ouml;posti">
      S&auml;hk&ouml;posti
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ftp-defaults-topic.html#d0e12169" title="FTP">
      FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-scan-topic.html#d0e12601" title="USB-asema">
      USB-asema
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e13206" title="Network/Ports (Verkko/Portit)">
      Network/Ports (Verkko/Portit)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e15221" title="Suojaus">
      Suojaus
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cloud-connector-menu-topic.html#cloud-connector-menu_fi" title="Cloud Connector">
      Cloud Connector
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e15935" title="Raportit">
      Raportit
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu_fi" title="Vianm&auml;&auml;ritys">
      Vianm&auml;&auml;ritys
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_fi" title="Tulostimen yll&auml;pito">
     Tulostimen yll&auml;pito
    </a>
   </p>
   <div id="divd0e16227">
    <p class="toc-2-style">
     <a href="checking-status-of-parts-and-supplies-topic.html#checking-status-of-parts-and-supplies_fi" title="Tulostimen osien ja tarvikkeiden tilan tarkistaminen">
      Tulostimen osien ja tarvikkeiden tilan tarkistaminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications_fi" title="Tarvikeilmoitusten m&auml;&auml;ritt&auml;minen">
      Tarvikeilmoitusten m&auml;&auml;ritt&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_fi" title="S&auml;hk&ouml;postih&auml;lytysten m&auml;&auml;ritt&auml;minen">
      S&auml;hk&ouml;postih&auml;lytysten m&auml;&auml;ritt&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-reports-topic.html#viewing-reports_fi" title="Raporttien tarkasteleminen">
      Raporttien tarkasteleminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies-group.html#ordering-supplies-group_fi" title="Tulostimen osien ja tarvikkeiden tilaaminen">
      Tulostimen osien ja tarvikkeiden tilaaminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e16498" title="Tulostimen osien ja tarvikkeiden vaihtaminen">
      Tulostimen osien ja tarvikkeiden vaihtaminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e16643" title="Tulostimen osien puhdistaminen">
      Tulostimen osien puhdistaminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e16731" title="Energian ja paperin s&auml;&auml;st&auml;minen">
      Energian ja paperin s&auml;&auml;st&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-printer-topic.html#moving-printer_fi" title="Tulostimen siirt&auml;minen toiseen paikkaan">
      Tulostimen siirt&auml;minen toiseen paikkaan
     </a>
    </p>
    <p class="toc-2-style">
     <a href="shipping-printer-topic.html#shipping-printer_fi" title="Tulostimen kuljettaminen">
      Tulostimen kuljettaminen
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_fi" title="Vianm&auml;&auml;ritys">
     Vianm&auml;&auml;ritys
    </a>
   </p>
   <div id="divd0e16892">
    <p class="toc-2-style">
     <a href="print-quality-problems-topic.html#print-quality-problems_fi" title="Tulostuslaatuongelmat">
      Tulostuslaatuongelmat
     </a>
    </p>
    <p class="toc-2-style">
     <a href="print-quality-is-poor-subgroup.html#d0e17003" title="Tulostusongelmat">
      Tulostusongelmat
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#trb-printer-not-responding_fi" title="Tulostin ei vastaa">
      Tulostin ei vastaa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_fi" title="Flash-asemaa ei voi lukea">
      Flash-asemaa ei voi lukea
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-usb-port-topic.html#enabling-usb-port_fi" title="USB-portin k&auml;ytt&ouml;&ouml;notto">
      USB-portin k&auml;ytt&ouml;&ouml;notto
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e19610" title="Verkkoyhteysongelmat">
      Verkkoyhteysongelmat
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e19828" title="Tarvikeongelmat">
      Tarvikeongelmat
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-jams.html#clearing-jams_fi" title="Tukosten poistaminen">
      Tukosten poistaminen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printer-problems.html#solving-printer-problems_fi" title="Paperinsy&ouml;tt&ouml;ongelmat">
      Paperinsy&ouml;tt&ouml;ongelmat
     </a>
    </p>
    <p class="toc-2-style">
     <a href="disabling-smtp-server-not-setup-error-topic.html#d0e20606" title="S&auml;hk&ouml;postiongelmat">
      S&auml;hk&ouml;postiongelmat
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-caller-id-not-shown-topic.html#d0e20725" title="Faksausongelmat">
      Faksausongelmat
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-scan-to-computer-topic.html#d0e21380" title="Skannausongelmat">
      Skannausongelmat
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_fi" title="Yhteyden ottaminen asiakastukeen">
      Yhteyden ottaminen asiakastukeen
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="recycle-dispose-chapter.html#recycle-dispose-chapter_fi" title="Kierr&auml;tys ja h&auml;vitt&auml;minen">
     Kierr&auml;tys ja h&auml;vitt&auml;minen
    </a>
   </p>
   <div id="divd0e22135">
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#recycling-lexmark-products_fi" title="Lexmark-tuotteiden kierr&auml;tt&auml;minen">
      Lexmark-tuotteiden kierr&auml;tt&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_fi" title="Lexmark-pakkauksen kierr&auml;tt&auml;minen">
      Lexmark-pakkauksen kierr&auml;tt&auml;minen
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_fi" title="Tiedotteet">
     Tiedotteet
    </a>
   </p>
   <div id="divd0e22170">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e22173" title="Tuotetiedot">
      Tuotetiedot
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e22190" title="Painosta koskeva tiedote">
      Painosta koskeva tiedote
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_fi" title="Tavaramerkit">
      Tavaramerkit
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_fi" title="K&auml;ytt&ouml;oikeustiedote">
      K&auml;ytt&ouml;oikeustiedote
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_fi" title="Emissiotaso">
      Emissiotaso
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_fi" title="S&auml;hk&ouml;- ja elektroniikkaromudirektiivi (SER)">
      S&auml;hk&ouml;- ja elektroniikkaromudirektiivi (SER)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e22296" title="Litiumioniakku">
      Litiumioniakku
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_fi" title="Asetus (EU) 2023/1542">
      Asetus (EU) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e22334" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_fi" title="Laitteen h&auml;vitt&auml;minen">
      Laitteen h&auml;vitt&auml;minen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_fi" title="Staattista s&auml;hk&ouml;&auml; koskeva tiedote">
      Staattista s&auml;hk&ouml;&auml; koskeva tiedote
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_fi" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_fi" title="L&auml;mp&ouml;tilatiedot">
      L&auml;mp&ouml;tilatiedot
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_fi" title="Laserilmoitus">
      Laserilmoitus
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_fi" title="Virrankulutus">
      Virrankulutus
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#regulatory-notices-for-telecommunication-terminal-equipment_fi" title="Tietoliikennep&auml;&auml;telaitteita koskevat s&auml;&auml;nn&ouml;kset">
      Tietoliikennep&auml;&auml;telaitteita koskevat s&auml;&auml;nn&ouml;kset
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e22580" title="Langattomia tuotteita koskevat s&auml;&auml;nn&ouml;kset">
      Langattomia tuotteita koskevat s&auml;&auml;nn&ouml;kset
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_fi" title="Ilmoitus modulaarisista komponenteista">
      Ilmoitus modulaarisista komponenteista
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_fi" title="Altistus radiotaajuuss&auml;teilylle">
      Altistus radiotaajuuss&auml;teilylle
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e22605" title="Euroopan yhteis&ouml;n (EY) direktiivien mukainen ilmoitus">
      Euroopan yhteis&ouml;n (EY) direktiivien mukainen ilmoitus
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-b_fi" title="Euroopan yhteis&ouml;n (EY) direktiivien mukainen ilmoitus">
      Euroopan yhteis&ouml;n (EY) direktiivien mukainen ilmoitus
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue